import Logo from './components/Logo';
import Home from './components/Home';
import Library from './components/Library';
import Searchbooks from './components/Searchbooks';
import Magazines from './components/Magazines';
import Messages from './components/Messages';
import UserCircle from './components/UserCircle';
import TikTok from './components/TikTok';
import Facebook from './components/Facebook';
import Instagram from './components/Instagram';
import Youtube from './components/Youtube';
import Close from './components/Close';
import Search from './components/Search';
import ArrowDown from './components/ArrowDown';

export const icons = {
    logo: Logo,
    home: Home,
    library: Library,
    searchbooks: Searchbooks,
    magazines: Magazines,
    messages: Messages,
    userCircle: UserCircle,
    tiktok: TikTok,
    facebook: Facebook,
    instagram: Instagram,
    youtube: Youtube,
    close: Close,
    search: Search,
    arrowDown: ArrowDown
}
